(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ks-main-product"]) return;
  try {
    
(function () {
  'use strict';

  function initPdp(scope) {
    var root = scope || document;

    // ── Gallery: desktop crossfade + thumbs ──────────────────────
    var slides   = root.querySelectorAll('[data-gallery-slide]');
    var thumbs   = root.querySelectorAll('[data-gallery-thumb]');

    function activateSlide(idx) {
      slides.forEach(function (s) {
        s.classList.toggle('is-active', parseInt(s.dataset.gallerySlide, 10) === idx);
      });
      thumbs.forEach(function (t) {
        var active = parseInt(t.dataset.index, 10) === idx;
        t.classList.toggle('is-active', active);
        t.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        activateSlide(parseInt(t.dataset.index, 10));
      });
    });

    // ── Mobile carousel + dot sync ───────────────────────────────
    var carousel = root.querySelector('.ks-pdp__carousel');
    var dots     = root.querySelectorAll('.ks-pdp__dot');

    if (carousel && dots.length) {
      carousel.addEventListener('scroll', function () {
        var idx = Math.round(carousel.scrollLeft / carousel.offsetWidth);
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
      }, { passive: true });

      dots.forEach(function (dot, i) {
        dot.addEventListener('click', function () {
          carousel.scrollTo({ left: i * carousel.offsetWidth, behavior: 'smooth' });
        });
      });
    }

    // ── Size pills ───────────────────────────────────────────────
    var pills    = root.querySelectorAll('[data-size-pill]');
    var hiddenId = root.querySelector('[data-atc-form] input[name="id"]');

    pills.forEach(function (pill) {
      pill.addEventListener('click', function () {
        if (pill.dataset.soldOut) return;
        pills.forEach(function (p) { p.classList.remove('is-selected'); });
        pill.classList.add('is-selected');
        if (hiddenId) hiddenId.value = pill.dataset.variantId;
      });
    });

    // ── Size guide modal ─────────────────────────────────────────
    //    Uses CLASS-BASED activation to match theme.css.liquid:
    //      backdrop → .is-open     (opacity 1, pointer-events all)
    //      modal    → .ks-sg--open (translateY 0, pointer-events auto)
    //    The old aria-hidden approach was ignored by the CSS and left
    //    the modal's pointer-events blocking page scroll when "hidden".
    var backdrop  = root.querySelector('.ks-modal-backdrop');
    var modal     = root.querySelector('[data-size-guide]');
    var openBtns  = root.querySelectorAll('[data-size-guide-open]');
    var closeBtns = root.querySelectorAll('[data-size-guide-close]');

    function openSizeGuide() {
      if (!modal) return;
      modal.classList.add('ks-sg--open');
      modal.setAttribute('aria-hidden', 'false');
      if (backdrop) backdrop.classList.add('is-open');
      document.body.style.overflow = 'hidden';
    }
    function closeSizeGuide() {
      if (!modal) return;
      modal.classList.remove('ks-sg--open');
      modal.setAttribute('aria-hidden', 'true');
      if (backdrop) backdrop.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    openBtns.forEach(function (b) { b.addEventListener('click', openSizeGuide); });
    closeBtns.forEach(function (b) { b.addEventListener('click', closeSizeGuide); });
    if (backdrop) backdrop.addEventListener('click', closeSizeGuide);

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('ks-sg--open')) {
        closeSizeGuide();
      }
    });

    // ── Size guide unit toggle (CM / IN) ─────────────────────────
    var unitBtns  = root.querySelectorAll('.ks-sg__unit-btn');
    var dataCells = root.querySelectorAll('.ks-sg__td[data-cm]');

    unitBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var unit = btn.dataset.unit; // 'cm' or 'in'
        unitBtns.forEach(function (b) {
          b.classList.toggle('is-active', b.dataset.unit === unit);
          b.setAttribute('aria-pressed', b.dataset.unit === unit ? 'true' : 'false');
        });
        dataCells.forEach(function (cell) {
          cell.textContent = cell.dataset[unit];
        });
      });
    });

    // ── Sticky mobile ATC ────────────────────────────────────────
    var mainAtc    = root.querySelector('.ks-pdp__atc');
    var stickyBar  = root.querySelector('.ks-pdp-sticky');
    var stickyBtn  = root.querySelector('[data-sticky-atc]');

    if (mainAtc && stickyBar && window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          var show = !e.isIntersecting;
          stickyBar.classList.toggle('is-visible', show);
          stickyBar.setAttribute('aria-hidden', show ? 'false' : 'true');
        });
      }, { threshold: 0, rootMargin: '0px 0px -60px 0px' });

      io.observe(mainAtc);
    }

    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        var form = root.querySelector('[data-atc-form]');
        if (form) {
          // Dispatch a native submit so Shopify's cart AJAX (if any) picks it up
          form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
          if (!form.dataset.ajaxCart) form.submit();
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', function () { initPdp(); });
  document.addEventListener('shopify:section:load', function (e) { initPdp(e.target); });
}());

  } catch(e) { console.error(e); }
})();
})();
